import styled from 'styled-components'

import { device } from '~/styles/device'

export const TabsWrapper = styled.nav`
  --buttonHeight: 2.375rem;
  --buttonHoverBG: var(--white);

  @media ${device.laptop_max} {
    --gutter: 0.25rem;
    --overflow: scroll;

    > * {
      min-width: 30vw;
      width: 30vw;
    }

    &::-webkit-scrollbar {
      display: none;
    }

    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  @media ${device.laptop} {
    --gutter: 0;
    --overflow: visible;

    flex-wrap: wrap;
  }

  display: flex;
  overflow: var(--overflow);
  max-width: 100vw;
  padding: 0 var(--gutter);
  border-bottom: var(--sl-border-base) !important;

  > a {
    height: calc(var(--buttonHeight) + 0.25rem);
    border-radius: var(--sl-radius-1);
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    font: var(--sl-text-action-font);
    color: var(--sl-fg-base-soft);

    &:hover {
      color: var(--sl-fg-base);
    }

    &:focus-visible {
      outline: none;
      box-shadow: var(--sl-focus-ring-base);
      color: var(--sl-fg-base);
    }

    &.active {
      border-bottom: 2px solid var(--sl-fg-accent);
      color: var(--sl-fg-accent);
      font-weight: var(--sl-font-weight-semibold);
    }
  }
`
